import React from "react"
import Admonition from "../../../components/Admonitions/Admonition"
import {Modal} from "../../../components/Modals/Modal"
import Button from "../../../components/Button/Button"

interface ClosureCheckErrorModalProps {
	error: string
	closeModal: () => void
	onSuccess: () => void
}

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function ClosureCheckErrorModal({error, closeModal, onSuccess}: ClosureCheckErrorModalProps) {
	return (
		<Modal classname="closure-check-modal" close={refreshAndClose(onSuccess, closeModal)}>
			<div className="modal-content">
				<h3 className="title is-4 text-closure-check">Issuing closure check is not available at this time</h3>
				<Admonition type="is-danger" title="Reason" message={<p>{error}</p>} />
			</div>
			<div className="modal-actions mt-4 is-flex is-justify-content-end">
				<Button className="button is-light" onClick={refreshAndClose(onSuccess, close)}>
					Close
				</Button>
			</div>
		</Modal>
	)
}
